var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vertical container",
    clipPath: "url(#clip0_626_14164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.97554 1.17539C4.25052 1.1906 4.50834 1.31386 4.69283 1.51834C4.87732 1.72281 4.97351 1.99191 4.96045 2.267C4.96045 2.90966 4.40565 3.30442 3.87324 3.77784C3.34773 4.24707 3.06468 4.50355 2.97305 4.56275C2.87327 4.49811 2.52474 4.18138 2.07287 3.77784C1.53815 3.30254 0.985657 2.90401 0.985657 2.267C0.972596 1.99191 1.06879 1.72281 1.25328 1.51834C1.43777 1.31386 1.69559 1.1906 1.97057 1.17539C2.1229 1.17078 2.27382 1.20577 2.40857 1.27694C2.54333 1.34811 2.65731 1.45304 2.73938 1.58145C2.91511 1.82726 2.94439 1.95027 2.97368 1.95027C3.00297 1.95027 3.03184 1.82726 3.20589 1.58082C3.28749 1.45181 3.40152 1.34648 3.53658 1.27533C3.67163 1.20419 3.82299 1.16973 3.97554 1.17539ZM3.97554 0.756995C3.78557 0.750913 3.59668 0.787765 3.42293 0.864806C3.24918 0.941848 3.09504 1.05709 2.97201 1.20196C2.84908 1.05752 2.69526 0.942536 2.52192 0.865518C2.34859 0.7885 2.16016 0.751412 1.97057 0.756995C1.58457 0.772089 1.22025 0.939413 0.957277 1.22238C0.694305 1.50534 0.554077 1.88093 0.567258 2.267C0.567258 3.02221 1.10072 3.486 1.61639 3.93432C1.6756 3.98578 1.73543 4.03766 1.79484 4.09059L2.00969 4.28264C2.244 4.50559 2.48965 4.71633 2.74565 4.914C2.81339 4.95786 2.89236 4.98119 2.97305 4.98119C3.05375 4.98119 3.13272 4.95786 3.20045 4.914C3.46461 4.71029 3.71781 4.49277 3.95901 4.26234L4.15189 4.08996C4.21319 4.03557 4.27532 3.98139 4.33704 3.92804C4.82531 3.50441 5.37885 3.0243 5.37885 2.267C5.39203 1.88093 5.2518 1.50534 4.98883 1.22238C4.72586 0.939413 4.36154 0.772089 3.97554 0.756995Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_14164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.02079,
    height: 5.02079,
    fill: "white",
    transform: "translate(0.462891 0.358887)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.e5a38c8534c56fc06579ed6f2dd53bb5.svg";
export { ForwardRef as ReactComponent };